export function shouldInputBePolyfilled(type) {
  const input = document.createElement('input')
  input.setAttribute('type', type)
  return input.type !== type
}
